import { useEffect } from "react";
import usePosOrderDeliveryMethod from "../atoms/usePosOrderDeliveryMethodAtom";
import usePosOrderUser from "../atoms/usePosOrderUser";
import useCartValidationPost from "../mutations/cart/useCartValidationPost";
import { useCart, useIsCartEmpty } from "./useCartHook";
import useDidMountEffect from "./useDidMountEffect";
import useDiscountCodeHook from "./useDiscountCodeHook";
import { useSetValidator } from "../atoms/usePosOrderValidatorAtom";
import { useSetPosOrderTip } from "../atoms/usePosOrderTipAtom";
import {
  defaultPosOrderCustomDiscount,
  useSetPosOrderCustomDiscount,
} from "../atoms/usePosOrderCustomDiscount";
import {
  defaultPosOrderDeliveryCost,
  useSetPosOrderDeliveryCost,
} from "../atoms/usePosOrderDeliveryCostAtom";
const VALIDATION_DEBOUNCE_MS = 400;

const useCartValidatorHook = (
  isKiosk = false,
  onSuccess?: () => void,
  onFail?: () => void
) => {
  const mutation = useCartValidationPost();
  const setValidator = useSetValidator();
  const { discountCode, resetDiscountCode } = useDiscountCodeHook();
  const [cart] = useCart();
  const isCartEmpty = useIsCartEmpty();
  const [orderUser] = usePosOrderUser();
  const [deliveryMethod] = usePosOrderDeliveryMethod();
  const setTip = useSetPosOrderTip();
  const setCustomDiscount = useSetPosOrderCustomDiscount();
  const setDeliveryCost = useSetPosOrderDeliveryCost();

  const shouldValidate = discountCode.isApplied || discountCode.code.length > 0;

  useEffect(() => {
    if (isCartEmpty) return;
    const timer = setTimeout(() => {
      if (mutation.isPending) return;
      mutation
        .mutateAsync({
          deliveryMethod: deliveryMethod,
          zipCode: orderUser?.zip_code,
          discountCode: discountCode?.code,
          cart: cart,
        })
        .then((data) => {
          if (isKiosk && discountCode.isApplied) {
            if (data.discount_code_validation === false) {
              onFail && onFail();
            } else {
              onSuccess && onSuccess();
            }
          }
        });
    }, VALIDATION_DEBOUNCE_MS);

    return () => clearTimeout(timer);
  }, [cart, deliveryMethod, orderUser, shouldValidate]);

  useEffect(() => {
    mutation.reset();
  }, [deliveryMethod]);

  useDidMountEffect(() => {
    if (isCartEmpty) {
      resetDiscountCode();
      setValidator(undefined);
      setDeliveryCost(defaultPosOrderDeliveryCost);
      setTip("-1");
      setCustomDiscount(defaultPosOrderCustomDiscount);
      mutation.reset();
    }
  }, [isCartEmpty]);

  return { isPending: mutation.isPending };
};

export default useCartValidatorHook;
